/**
 * Constantes centralizadas para tipologías de eventos
 * Este archivo centraliza todas las definiciones de tipos, categorías y opciones de eventos
 */

// Tipos principales de eventos
export const EVENT_TYPES = [
  'meetup',
  'competition', 
  'race',
  'adventure',
  'trip',
  'gathering',
  'course',
  'ride',
  'exhibition'
];

// Niveles de experiencia
export const EXPERIENCE_LEVELS = [
  'beginner',
  'intermediate', 
  'advanced'
];

// Tipos de tickets
export const TICKET_TYPES = [
  'free',
  'paid'
];

// Modalidades de evento
export const EVENT_MODALITIES = [
  'withVehicle', // true
  'personal'    // false
];

// Tipos de terreno
export const TERRAIN_TYPES = [
  'road',
  'offroad',
  'all'
];

// Constantes adicionales para mejor legibilidad
export const TERRAIN_ALL = TERRAIN_TYPES[2]; // 'all'
export const TERRAIN_ROAD = TERRAIN_TYPES[0]; // 'road'
export const TERRAIN_OFFROAD = TERRAIN_TYPES[1]; // 'offroad'

// Tipos de tickets con constantes adicionales
export const TICKET_FREE = TICKET_TYPES[0]; // 'free'
export const TICKET_PAID = TICKET_TYPES[1]; // 'paid'

// Objeto con todas las categorías para fácil acceso
export const EVENT_CATEGORIES = {
  types: EVENT_TYPES,
  experience: EXPERIENCE_LEVELS,
  tickets: TICKET_TYPES,
  modalities: EVENT_MODALITIES,
  terrain: TERRAIN_TYPES
};

// Función helper para validar tipos de eventos
export const isValidEventType = (type) => {
  return EVENT_TYPES.includes(type);
};

// Función helper para validar nivel de experiencia
export const isValidExperienceLevel = (level) => {
  return EXPERIENCE_LEVELS.includes(level);
};

// Función helper para validar tipo de terreno
export const isValidTerrainType = (terrain) => {
  return TERRAIN_TYPES.includes(terrain);
};

// Función helper para obtener el tipo por defecto
export const getDefaultEventType = () => EVENT_TYPES[0]; // 'meetup'

// Función helper para obtener la experiencia por defecto
export const getDefaultExperienceLevel = () => EXPERIENCE_LEVELS[0]; // 'beginner'

// Función helper para obtener el terreno por defecto
export const getDefaultTerrainType = () => TERRAIN_TYPES[0]; // 'road'